import { render } from "./HorsesListing.vue?vue&type=template&id=62dbd0fc&ts=true"
import script from "./HorsesListing.vue?vue&type=script&lang=ts"
export * from "./HorsesListing.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__